// Autogenerated by util/sync-labels/sync-labels.ts
// Do not edit this file directly.
// To regenerate this file, start ithriv_landing_service locally on port 8000 and
// run the following command in the root directory of the ithriv_web repository:
// > npm run sync_labels
import {LabelResponse} from '@backend';

export enum ProjectRole {
  OWNER = 'owner',
  COLLABORATOR = 'collaborator',
}

export const ProjectRoleLabels = {
  owner: 'Owner',
  collaborator: 'Collaborator',
} as const;

export type ProjectRoleId = keyof typeof ProjectRoleLabels;
export type ProjectRoleLabel = (typeof ProjectRoleLabels)[ProjectRoleId];

export const ProjectRoleOptions: Record<ProjectRole, LabelResponse> = {
  owner: {
    id: ProjectRole.OWNER,
    text: ProjectRoleLabels[ProjectRole.OWNER],
    sensitivity_level_id: null,
    display_order: null,
  },
  collaborator: {
    id: ProjectRole.COLLABORATOR,
    text: ProjectRoleLabels[ProjectRole.COLLABORATOR],
    sensitivity_level_id: null,
    display_order: null,
  },
} as const;
